import { Configurer } from '../Core/index';
import { Stack } from './Stack';

/**Stacks are a per-user named persistent queue of data. An administrator creates a stack service. End-users can push data on an arbitrary number of their own arbitrary named stacks*/
export class StackConfigurer extends Configurer {}
